import { render } from "./doctors-report.vue?vue&type=template&id=3bf38b2a&scoped=true"
import script from "./doctors-report.vue?vue&type=script&lang=js"
export * from "./doctors-report.vue?vue&type=script&lang=js"

import "./doctors-report.vue?vue&type=style&index=0&id=3bf38b2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf38b2a"]])

export default __exports__